import { makeStyles } from 'tss-react/mui';

export const useCatalogCreationMediaDropzoneStyles = makeStyles()((theme) => ({
  tile: {
    rowGap: theme.spacing(0.5),
    minWidth: 0,
    flexShrink: 1,
  },
  dropzone: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    width: '100%',
    aspectRatio: '1 / 1',
    borderRadius: theme.shape.borderRadiusLg,
    border: `1px dashed ${theme.palette.custom.border.primary}`,
    backgroundColor: 'transparent',
    transition: theme.transitions.create(['border-color', 'background-color']),
  },
  filledDropzone: {
    border: 'none',
  },
  dragActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.action.hover,
  },
  emptyContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: theme.spacing(0.5),
    width: '100%',
    height: '100%',
    padding: theme.spacing(1),
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    textAlign: 'center',
  },
  uploadingOverlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.custom.overlay,
  },
}));
